import { ProfileUserInitials } from '@apps-common/components/common/user'
import { ButtonRoundSm } from '@apps-common/components/elements'
import { commonIcons } from '@apps-common/config/icons'
import { IAppNavigationOptions } from '@apps-common/hooks/useNavigation'
import { IMyMonitoringAccountListModel } from '@apps-common/types/portal/my-monitoring'
import { ROUTE_MY_MONITORING_ACCOUNT_DETAILS } from '@apps-radionet-portal-root/src/config/private-routes'
import { MyMonitoringAccountSitePills } from '../MyMonitoringAccountSitePills'

export const buildTableKeys = (navigateForward: (opts: IAppNavigationOptions) => void) => [
  {
    title: '',
    key: 'name',
    thClasses: 'bg-primary-content/[0.05]',
    tdClasses: 'bg-secondary text-secondary-content',
    Component: (props: any) => <ProfileUserInitials classes='' name={`${props.firstName} ${props.lastName}`} />
  },
  {
    title: 'Email',
    key: 'email',
    thClasses: 'bg-primary-content/[0.05]',
    tdClasses: 'bg-secondary text-secondary-content'
  },
  {
    title: 'Name',
    key: 'firstName',
    thClasses: 'bg-primary-content/[0.05]',
    tdClasses: 'bg-secondary text-secondary-content',
    Component: (props: IMyMonitoringAccountListModel) => (
      <span className='capitalize'>
        {props.firstName} {props.lastName}
      </span>
    )
  },
  {
    title: 'Device Count',
    key: 'unitCount',
    thClasses: 'bg-primary-content/[0.05] text-center',
    tdClasses: 'bg-secondary text-secondary-content',
    Component: (props: IMyMonitoringAccountListModel) => {
      const { unitCount } = props

      return (
        <div className='flex items-center justify-center gap-[3px]'>
          <div className='flex items-center justify-center gap-[5px] bg-surface-2 text-text border border-border text-[0.85em] rounded-full pr-3 px-2 py-1'>
            <div className='bg-surface-w text-text px-1 rounded'>{unitCount}</div>{' '}
            <span className='jost-medium'>{unitCount === 1 ? 'Device' : 'Devices'}</span>
          </div>
        </div>
      )
    }
  },
  {
    title: 'Sites',
    key: 'units',
    thClasses: 'bg-primary-content/[0.05]',
    tdClasses: 'bg-secondary text-secondary-content',
    Component: (props: IMyMonitoringAccountListModel) => <MyMonitoringAccountSitePills props={props} />
  },
  {
    title: 'Actions',
    key: 'actions',
    static: true,
    thClasses: 'text-right bg-primary-content/[0.05]',
    tdClasses: 'bg-secondary text-secondary-content',
    Component: (props: any) => (
      <div className='flex items-center justify-end gap-[5px]'>
        <ButtonRoundSm
          type='button'
          className='action-brand-solid'
          callback={(e) => {
            e?.stopPropagation()
            navigateForward({
              routeUrl: ROUTE_MY_MONITORING_ACCOUNT_DETAILS.buildPath(props.id),
              route: ROUTE_MY_MONITORING_ACCOUNT_DETAILS
            })
          }}
          tooltip={{ id: 'navigate-my-monitoring-account', message: 'View account' }}
        >
          <commonIcons.arrowAngled />
        </ButtonRoundSm>
      </div>
    )
  }
]
